import { Injectable } from "@angular/core"
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from "@angular/common/http"
import { Observable, catchError, filter, finalize, of, tap } from "rxjs"
import { LoadingService } from "../services"
import { environment } from "src/environments/environment"

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private loadingService: LoadingService) { }

    private static readonly _backgroundRoutes = ["/lookup", "/edp-data", "/employees"]
    
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const isApiCall =
            request.url.includes(environment.apiBaseUrl) &&
            !LoadingInterceptor._backgroundRoutes.some(route => request.url.includes(route))
        const postfix = isApiCall ? request.url.split(environment.apiBaseUrl)[1] : ""
        let decremented = false

        const decrementOnce = () => {
            if (isApiCall && !decremented) {
                decremented = true
                this.loadingService.decrement(postfix)
            }
        }

        if (isApiCall) this.loadingService.increment(postfix)

        return next.handle(request).pipe(
            filter(event => event instanceof HttpResponse),
            tap(() => {
                decrementOnce()
                return of()
            }),
            catchError(err => {
                decrementOnce()
                throw err
            }),
            finalize(() => decrementOnce())
        )
    }
}

